import * as moment from "moment";
import { stateConvert } from "web/components/utils/stateAbbreviation";

export const scheduledPostsCsvExportHeader = [
  { id: "refNo", displayName: "Ref No" },
  { id: "customerName", displayName: "Customer Name" },
  { id: "poNumber", displayName: "P.O. Number" },
  { id: "orderNumber", displayName: "Order Number" },
  { id: "locationName", displayName: "Location Name" },
  { id: "addressCityState", displayName: "Address-City State" },
  { id: "type", displayName: "Type" },
  { id: "quantityOrderType", displayName: "Quantity-Order Type" },
  { id: "rdd", displayName: "Req. Del/Pickup Date" },
  { id: "supplierNameCityState", displayName: "Supplier Name-City-State" },
  { id: "supplierEmail", displayName: "Supplier Email" },
  { id: "supplierPhoneNo", displayName: "Supplier Phone No" },
  { id: "price", displayName: "Supplier Price" },
  { id: "status", displayName: "Status" },
  { id: "tenderedDate", displayName: "Tendered Date" },
];

export const setScheduledPostsCsvExportData = (pagedata) => {
  const orderType = (items) => {
    const totalQuantity = items?.quantityDetails?.totalQuantity;
    if (items?.requestType === 'PickUp') return `${totalQuantity}, NA`;

    let condition;
    if (items?.palletDetails?.condition?.length !== 1) condition = items?.palletDetails?.condition?.join(', ');
    else if (items?.palletDetails?.condition?.length !== 0) condition = items?.palletDetails?.condition;

    let palletType, size = '', grade = '', LWH, heatTreated = '';

    if (items?.palletDetails?.material !== 'WOOD') {
      const { length, width, height } = items?.palletDetails || {};
      LWH = `${length}x${width}x${height}`;
      if (condition) {
        condition = condition?.toString()?.toLowerCase()?.replace(/\b\w/g, c => c.toUpperCase());
        return `${totalQuantity}, ${LWH}, ${condition}`;
      }
      return `${totalQuantity}, ${LWH}`;
    }

    palletType = items?.palletDetails?.palletType;
    if (items?.palletDetails?.size) {
      size = items.palletDetails.size === 'Custom'
        ? `, ${items.palletDetails.length}x${items.palletDetails.width}x${items.palletDetails.height}`
        : `, ${items.palletDetails.size}`;
    }

    if (items?.palletDetails?.grade) grade = `, ${items.palletDetails.grade}`;

    palletType = palletType?.toLowerCase()?.replace(/\b\w/g, c => c.toUpperCase());
    condition = condition?.toString()?.toLowerCase()?.replace(/\b\w/g, c => c.toUpperCase());

    if (items?.palletDetails?.newConditionType) {
      const type = items.palletDetails.newConditionType === 'HARDWOOD' ? '(HW)' : items.palletDetails.newConditionType === 'SOFTWOOD' ? '(SW)' : '';
      if (type) condition = `${condition} ${type}`;
    }

    if (items?.palletDetails?.heatTreared) heatTreated = ', HT';
    return `${totalQuantity}${size}${grade}-${palletType}-${condition}${heatTreated}`;
  };

  const wrapInQuotes = (value) => (value === null || value === undefined || value === '') ? '"NA"' : `"${value.toString().replace(/"/g, '""')}"`;

  const tempCSVData = pagedata?.map(items => ({
    refNo: items.orderRefNumber || 'NA',
    customerName: items?.addressDTO?.name || 'NA',
    poNumber: items.poNumber || 'NA',
    orderNumber: items.orderNo && items.orderNo !== '' ? items.orderNo : 'NA',
    locationName: items?.ptPostedDetailsDTO?.shippingAddress?.locationName || items?.addressDTO?.locationName || 'NA',
    addressCityState: items?.ptPostedDetailsDTO?.shippingAddress
      ? `${items.ptPostedDetailsDTO.shippingAddress.street}-${items.ptPostedDetailsDTO.shippingAddress.city} ${stateConvert(items.ptPostedDetailsDTO.shippingAddress.state) || items.ptPostedDetailsDTO.shippingAddress.state}`
      : items.addressDTO
        ? `${items.addressDTO.street}-${items.addressDTO.city}-${stateConvert(items.addressDTO.state) || items.addressDTO.state}`
        : 'NA',
    type: items.requestType === 'PickUp' ? 'Pickup' : 'Delivery',
    quantityOrderType: orderType(items),
    rdd: items.requestType === 'PickUp'
      ? `${moment(items.requestDeliveryDate).format('MM/DD/YYYY')} ${items.deliveryFromTime}-${items.deliveryToTime}`
      : items?.ptPostedDetailsDTO
        ? `${moment(items.ptPostedDetailsDTO.requestDeliveryDate).format('MM/DD/YYYY')} ${items.ptPostedDetailsDTO?.deliveryWindowBegin && items.ptPostedDetailsDTO?.deliveryWindowEnd && items.ptPostedDetailsDTO?.deliveryWindowEnd !== 'null'
          ? `${items.ptPostedDetailsDTO.deliveryWindowBegin}-${items.ptPostedDetailsDTO.deliveryWindowEnd}`
          : items.ptPostedDetailsDTO.deliveryWindowBegin || 'NA'
        }`
        : `${moment(items.requestDeliveryDate).format('MM/DD/YYYY')} ${items.deliveryFromTime}-${items.deliveryToTime}`,
    supplierNameCityState: items?.tenderDetails
      ? `${items.tenderDetails.postedTo || 'NA'}-${items.tenderDetails.city}-${stateConvert(items.tenderDetails.state) || items.tenderDetails.state}`
      : 'NA',
    supplierEmail: (items?.tenderDetails?.email && items.tenderDetails.email[0]) ? items.tenderDetails.email.join(', ') : 'NA',
    supplierPhoneNo: (items?.tenderDetails?.phoneNumber && items.tenderDetails.phoneNumber[0]) ? items.tenderDetails.phoneNumber.join(', ') : 'NA',
    price: (items?.tenderDetails?.vendorPrice && items.tenderDetails.vendorPrice.length >= 1)
      ? items.tenderDetails.vendorPrice.map(price => `$${Number(price).toFixed(2)}`).join(' ')
      : 'NA',
    status: items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus || 'NA',
    tenderedDate: items?.tenderDetails?.tenderDate || moment(items?.createdAt * 1000).format('MM/DD/YYYY') || 'NA',
  }));

  return tempCSVData.map(obj => Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, wrapInQuotes(v)])));
};

export const palletTypeOptions = [
  {
    "label": "Grade A",
    "value": "GRADE_A_48x40"
  },
  {
    "label": "Grade A1",
    "value": "GRADE_A1_48x40"
  },
  {
    "label": "Grade B",
    "value": "GRADE_B_48x40"
  },
  {
    "label": "Odd",
    "value": "ODD"
  },
  {
    "label": "Scrap",
    "value": "SCRAP"
  },
]